import { Component } from '@angular/core';
import { ModalsComponent } from '../modals.component';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'modal-check-parent',
  templateUrl: './check-parent.component.html',  
  styleUrls:['./check-parent.component.scss'],
})
export class CheckParentComponent extends ModalsComponent {
  currentTab:'local'|'foreigner'|'info' = 'local';
  constructor(
    modalRef:BsModalRef,
  ) { 
    super(modalRef);
  }
  
  //
  cancel() {
    this.modalRef.hide(); 
  }
}